"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationError = exports.ConflictError = exports.NotFoundError = exports.ForbiddenError = exports.UnauthorizedError = exports.BadRequestError = exports.InternalServerError = exports.ApiError = exports.BaseError = void 0;
/**
 * BaseError is the base class for all internal errors.
 * It must not be exposed directly to any client or api consumer.
 */
class BaseError extends Error {
    constructor(message, details) {
        super(message);
        this.type = this.constructor.name;
        this.name = this.constructor.name;
        this.details = details;
    }
}
exports.BaseError = BaseError;
/**
 * ApiError is the base class for all errors that can be exposed to consumers.
 */
class ApiError extends BaseError {
}
exports.ApiError = ApiError;
class InternalServerError extends ApiError {
}
exports.InternalServerError = InternalServerError;
class BadRequestError extends ApiError {
}
exports.BadRequestError = BadRequestError;
class UnauthorizedError extends ApiError {
}
exports.UnauthorizedError = UnauthorizedError;
class ForbiddenError extends ApiError {
}
exports.ForbiddenError = ForbiddenError;
class NotFoundError extends ApiError {
}
exports.NotFoundError = NotFoundError;
class ConflictError extends ApiError {
}
exports.ConflictError = ConflictError;
/**
 * ValidationError is a specific type of BadRequestError.
 * It can be built from a Zod validation error.
 */
class ValidationError extends BadRequestError {
    static buildFromZodError(error) {
        return new ValidationError(error.message, { issues: error.issues });
    }
}
exports.ValidationError = ValidationError;
//# sourceMappingURL=error.js.map